import formatUserData from '../utils/formatUserData';
import store from '../store';
import axios from 'axios';
axios.defaults.baseURL = CRMHost;

const isValidContactId = function(userDetails) {
    if (!userDetails.cid) {
        return false;
    }

    // strip {}
    userDetails.cid = userDetails.cid.replace(/[{}]/g, "");

    // sanitise
    let RegExpGUID = RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
    if(!RegExpGUID.test(userDetails.cid)) {
        return false;
    }

    return userDetails;
};

export default {
    register: () => {
        console.info("CRM_register");
        console.time("CRM_register");

        return axios.post('/api/v1/user').then(result => formatUserData(result.data.contact));
    },
    retrieveUserRecord: () => {
        console.info("CRM_retrieveUserRecord");
        console.time("CRM_retrieveUserRecord");

        return axios.get('/api/v1/user/me').then(result => formatUserData(result.data)).catch((err) => {
            // console.log('me call exception', err);
        });

        // return new Promise(resolve => resolve()); // simulate returning empty promise
    },
    retrieveUserRecordSocial: () => {
        console.info("CRM_retrieveUserRecordSocial");
        console.time("CRM_retrieveUserRecordSocial");

        return axios.get('/api/v1/user/me').then(result => formatUserData(result.data));
    },
    updateUser: userData => {
        console.info("CRM_updateUser");
        console.time("CRM_updateUser");

        userData.cid = store.state.user.user.username;
        userData.email = store.state.user.user.email;
        return axios.put('/api/v1/user/me', userData).then(result => formatUserData(result.data));
    },
    updateUserDetails: userDetails => {
        console.info("CRM_updateUserDetails");
        console.time("CRM_updateUserDetails");

        userDetails.cid = store.state.user.user.username;
        userDetails.email = store.state.user.user.email;
        return axios.put('/api/v1/user/me/details', userDetails).then(result => formatUserData(result.data))
    },
    createEoi: eoi => {
        console.info("CRM_createEoi");
        console.time("CRM_createEoi");

        return axios.post('/api/v1/user/eoi', eoi).then(result => result.data)
    },
    sendPinpointMessage: payload => {
        console.info("CRM_sendPinpointMessage");
        console.time("CRM_sendPinpointMessage");

        return axios.post(
            '/api/v1/user/eoi/trigger-pinpoint',
            { email : payload.email, app_id: payload.app_id }
        )
    },
    skipPreferenceSelection: () => {
        console.info("CRM_skipPreferenceSelection");
        console.time("CRM_skipPreferenceSelection");

        return axios.post('/api/v1/user/me/onboarding/skip').then(result => {
            if (!result.data.success) {
                throw {global: 'Something went wrong.'};
            }
        });
    },
    skipPreferenceSelectionRego: () => {
        console.info("CRM_skipPreferenceSelectionRego");
        console.time("CRM_skipPreferenceSelectionRego");

        return axios.post('/api/v1/user/me/onboarding/skip').then(result => {
            if (!result.data.success) {
                throw {global: 'Something went wrong.'};
            }
        }).catch((err) => {
            // console.log('onboarding/skip call from rego exception', err);
        });
    },
    getSubscriptions: (userDetails) => {
        console.info("CRM_getSubscriptions");
        console.time("CRM_getSubscriptions");

        userDetails = isValidContactId(userDetails);
        if (!userDetails) {
            return Promise.reject("Invalid Dynamo Contact Id");
        }
        return axios.get('/api/v1/user/subscriptions', {params: userDetails}).then(result => formatUserData(result.data))
    },
    updateSubscriptions: (userDetails) => {
        console.info("CRM_updateSubscriptions");
        console.time("CRM_updateSubscriptions");

        userDetails = isValidContactId(userDetails);
        if (!userDetails) {
            return Promise.reject("Invalid Dynamo Contact Id");
        }
        return axios.put('/api/v1/user/subscriptions', userDetails).then(result => formatUserData(result.data))
    },
    optin: async (param) => {
        console.info("CRM_optin");
        console.time("CRM_optin");

        const user = store.state.user.user;

        if (user) {
            const optinData = {
                cid: user.username,
                email: user.email,
                signed_shirt: param.optin
            };

            return axios.post('/api/v1/user/fan-offers', optinData).then(result => {
                localStorage.removeItem('optInFanOffer');
                return result;
            }).catch(error => {
                return error;
            });
        } else {
            return false;
        }
    },
    getOptInOffers: async () => {
        console.info("CRM_getOptInOffers");
        console.time("CRM_getOptInOffers");

        const user = store.state.user.user;

        if (user) {

            return axios.get('/api/v1/user/fan-offers').then(result => {
                return result;
            }).catch(error => {
                return error;
            });

        } else {
            return false;
        }
    }
}